import {
  TYPE2CLASS
} from '../core/icon-class';
// import {
//   AlertModalController
// } from './editor/alert-modal.component';

require('./filter-dimension-node.component.scss');

class FilterDimensionNodeController {
  constructor(
    $element,
    $timeout,
    $scope,
    CurrentFilterService,
    PermissionService,
    $rootScope,
    RouterService,
    FilterResource,
    $modal,
    AggregateDataService,
    CurrentModelService,
    StatusCheckerService,
    ErrorHandlerService,
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.permission = PermissionService;
    this.currentFilter = CurrentFilterService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.filterBar = CurrentFilterService.filterBar;
    this.TYPE2CLASS = TYPE2CLASS;
    this.$rootScope = $rootScope;
    this.router = RouterService;
    this.FilterResource = FilterResource;
    this.$modal = $modal;
    this.AggregateDataService = AggregateDataService;
    this.CurrentModelService = CurrentModelService;
    this.StatusCheckerService = StatusCheckerService;
    this.AggregateDataService.filterData$.subscribe(() => {
      this.initDimensions();
    });


    this.adminPanelPaths = {
      'agent_agent': '/admin/agent/agent/',
      'agent_account': '/admin/agent/account/',
      'agent_application': '/admin/agent/application/',
      'agent_device': '/admin/agent/device/',
    };
  }

  initDimensions() {
    let dimensionArr = this.dimension.split('@');
    this.dimensionName = dimensionArr[0];
    this.dimensionHier = '';
    this.dimensionLevel = '';
    if (dimensionArr.length > 1) {
      dimensionArr = dimensionArr[1].split(':');
      this.dimensionHier = dimensionArr[0];
      this.dimensionLevel = dimensionArr.length > 1 ? dimensionArr[1] : '';
    }
    this.isAdminPanel = this.adminPanelPaths[this.dimensionName];
    this.hasRules = this.isHasRules;
    this.isAssignSchedule = this.dimension.indexOf('agent_agent@computer_name:computer_name') === 0 ||
      this.dimension.indexOf('agent_account@user_name:user_name') ||
      this.dimension.indexOf('agent_account@full_name:full_name') ||
      this.dimension.indexOf('agent_account@office:office');

    this.isAccountUserName = this.dimension.indexOf('agent_account@user_name:user_name') === 0;
    this.isAccountFullName = this.dimension.indexOf('agent_account@full_name:full_name') === 0;
    this.isAddToFilter = this.dimension.indexOf('agent_application@app_name:app_name') != -1 ||
      this.dimension.indexOf('agent_web@site:site') != -1;

    this.isAgentComputerName = this.dimension.indexOf('agent_agent@computer_name:computer_name') === 0;
    const hideProperties = {
      'agent_account@groups:groups': true,
      'agent_application@window_title:window_title': true,
    };

    this.showProperties = !hideProperties[this.dimension] && (this.dimension.indexOf('agent_account@user_name:user_name') != -1 ||
      this.dimension.indexOf('agent_agent@computer_name:computer_name') != -1 ||
      this.dimension.indexOf('agent_account@office:office') != -1 ||
      (this.dimensionName in this.adminPanelPaths) ||
      this.hasRules);

    this.isHasCard = this.hasCard();

    // }, 0);
  }

  getAssignScheduleRef(cell) {
    return `/admin/work_calendar/weekscheduledimension/add/?dimension=${
      this.dimension}&value=${this.getCellLabel(cell)}`;
  }

  get filter() {
    return this.currentFilter.filter;
  }

  get dimension() {
    return this.filterBar.drilldown[0];
  }

  get isNameOrdered() {
    return this.router.aggregateOrder === 'nameAsc' || this.router.aggregateOrder === 'nameDesc';
  }

  get aggregate() {
    return this.AggregateDataService.aggregate;
  }

  get model() {
    return this.CurrentModelService.model;
  }

  get isLoading() {
    return this.AggregateDataService.loading;
  }

  get isLoadingMore() {
    return this.AggregateDataService.loadingMore;
  }

  get cells() {
    return this.aggregate && this.aggregate.cells || [];
  }

  get total() {
    return this.hasData ? {
      cells: this.aggregate.cells.length,
      events: this.AggregateDataService.events.total,
      max: this.AggregateDataService.events.max
    } : {
      cells: 0,
      events: 0,
      max: 0
    };
  }

  shadowWidth(cell) {
    if (!cell.record_count || !this.total.max) return '0';
    return `${cell.record_count / this.total.max * 100}%`;
  }

  get hasData() {
    return (this.aggregate &&
      this.aggregate.cells &&
      this.aggregate.cells.length > 0);
  }

  addToFilter(cell) {
    this.router.changeCut(this.dimension, this.getCellLabel(cell), 'cut-edit');
  }

  get isHasRules() {
    const dim = this.model.dimensions.find(dm => dm.name === this.dimensionName);
    if (!dim) return false;
    const hierarchy = dim.hierarchies.find(h => h.name === this.dimensionHier);
    if (!hierarchy) return false;
    return hierarchy.rule_groups.length > 0;
  }

  hasCellFilter(cell) {
    const filter = this.model.getCellFilter(this.dimension, cell);
    return this.filter.hasFilter(filter);
  }

  getCellFilter(cell) {
    return this.model.getCellFilter(this.dimension, cell);
  }

  openPanel(cell) {
    let path = this.adminPanelPaths[this.dimensionName];
    let key = `${this.dimensionName}.id`;
    if (key in cell && cell[key]) {
      path = `${path}?id__exact=${cell[key]}`;
    } else {
      key = `${this.dimensionName}.${this.dimensionLevel}`;
      if (this.dimension === 'agent_agent@config_id:config_id') path = `/admin/agent/agent/?config__id__exact=${cell[key]}`;
      else path = `${path}?${this.dimensionLevel}__exact=${cell[key]}`;
    }
    if (cell[key]) window.open(path, '_blank').focus();
  }

  getCellLabel(cell) {
    return cell.cellLabel;
  }

  setCellFilter(cell) {
    const filter = this.getCellFilter(cell);
    filter.predicates = ['@'];
    this.filter.toggleFilter(filter);
    this.$scope.$root.$broadcast('dimensionToggle');
    this.router.filterChanged();
  }

  hasCard() {
    return this.permission.policies && [
      'agent_agent',
      'agent_account',
      'agent_application',
      'agent_web',
      'agent_networkconnection',
      'agent_attachedfile',
      'agent_device',
      'agent_dialog',
      'agent_appinstallation',
      // 'analytidcs_filter',
    ].some((dim) => this.dimension.startsWith(dim));
  }

  openCard(cell) {
    const filter = this.getCellFilter(cell);
    this.router.openCard(filter);
  }

  openRules(cell) {
    const cutObj = this.getCellFilter(cell);
    this.router.changeCut(cutObj.dimension, cutObj.label, 'rules-edit');
  }

  connectRemote(cell, i) {
    if (this.menuItem == cell) {
      this.menuItem = null;
      return;
    }
    if (cell.remote && cell.remote.length === 1) this.connectRemoteUser(cell.remote[0]);
    else if (i >= 0) this.connectRemoteUser(cell.remote[i]);
  }

  connectRemoteUser(remoteCell) {
    this.menuItem = null;
    if (this.router.isRemoteOpened(remoteCell)) return;
    if (remoteCell.sid)
      this.router.openFrame(`/remote/?hwid=${remoteCell.hwid}/${remoteCell.sid}`);
    else
      this.router.openFrame(`/remote/?hwid=${remoteCell.hwid}`);
  }

}

export const FilterDimensionNodeComponent = {
  template: require('./filter-dimension-node.component.html'),
  controller: FilterDimensionNodeController,
};



// WEBPACK FOOTER //
// ./src/filter/filter-dimension-node.component.js